/* __next_internal_client_entry_do_not_use__ BrandPromoText auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { PROMO_HIGHLIGHT } from "@faire/retailer-visitor-shared/consts/colors";
import { AssignSettingSaleColor } from "@faire/retailer-visitor-shared/settings/AssignSettingSaleColor";
import { useSettingUpdateSaleColorCopy } from "@faire/retailer-visitor-shared/settings/useSettingUpdateSaleColorCopy";
import { eventsThemeColors } from "@faire/web--source/slate/Theme/eventsThemeColors";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";
import styled, { css } from "styled-components";
export var BrandPromoText = function(param) {
    var isHighlightedPromo = param.isHighlightedPromo, promoText = param.promoText;
    if (!promoText) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            !isHighlightedPromo ? /*#__PURE__*/ _jsx(AssignSettingSaleColor, {}) : null,
            isHighlightedPromo ? /*#__PURE__*/ _jsx(Typography, {
                "data-test-id": "highlighted-promo-text",
                variant: "paragraphSansMedium",
                color: eventsThemeColors.faireMarket.promoText,
                children: promoText
            }) : /*#__PURE__*/ _jsx(NoneHighlightPromoText, {
                promoText: promoText
            })
        ]
    });
};
var NoneHighlightPromoText = function(param) {
    var promoText = param.promoText;
    var isUpdateSaleColorCopy = useSettingUpdateSaleColorCopy();
    return /*#__PURE__*/ _jsx(StyledContainer, {
        children: /*#__PURE__*/ _jsx(StyledTypography, {
            "data-test-id": "non-highlighted-promo-text",
            $showUpdateSaleColorCopy: isUpdateSaleColorCopy,
            variant: isUpdateSaleColorCopy ? "labelSansRegular" : "paragraphSansRegular",
            color: isUpdateSaleColorCopy ? Core.text.default : Decorative.shade.orange,
            children: promoText
        })
    });
};
var StyledTypography = styled(Typography).withConfig({
    componentId: "sc-c164818e-0"
})([
    "",
    ""
], function(props) {
    return props.$showUpdateSaleColorCopy && css([
        "background-color:",
        ";border-radius:4px;display:inline-block;padding:2px 3px;"
    ], PROMO_HIGHLIGHT);
});
var StyledContainer = styled.div.withConfig({
    componentId: "sc-c164818e-1"
})([
    "width:100%;"
]);
